import { render, staticRenderFns } from "./AddOrUpPage.vue?vue&type=template&id=2eb29336&scoped=true&"
import script from "./AddOrUpPage.vue?vue&type=script&lang=js&"
export * from "./AddOrUpPage.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpPage.vue?vue&type=style&index=0&id=2eb29336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb29336",
  null
  
)

component.options.__file = "AddOrUpPage.vue"
export default component.exports